/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getTimesheetDocumentContentPathParamsSchema = z.object({
  documentId: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getTimesheetDocumentContent200Schema = z.any();

export const getTimesheetDocumentContentQueryResponseSchema = z.lazy(
  () => getTimesheetDocumentContent200Schema,
);
